import { useEffect, useState } from "react";
import { fetchExpertDashboardData , fetchSkillsData} from "../Services/ExpertDashboardServices";
const useExpertDashboard = () => {
  const [dashboardData, setDashboardData] = useState(null);
  const [ skills, setSkills] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  

  useEffect(() => {
    const fetchData = async () => {
      try {
        const token = localStorage.getItem("token");
        const data = await fetchExpertDashboardData(token);
        console.log(".........expert ...data",data);
        setDashboardData(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

     const fetchSkills = async () => {
          try {
            const token = localStorage.getItem("token");
            const data = await fetchSkillsData();
            console.log("..........skills ..data",data);
            setSkills(data);
          } catch (err) {
            setError(err.message);
          } finally {
            setLoading(false);
          }
        };

    

    fetchData();
    fetchSkills();




  }, []);

  return { dashboardData, skills, loading, error };
};

export default useExpertDashboard;
